// Full transform — used to auto-generate a slug from a separate field (name/
// title) where the whole string arrives at once, so collapsing separators
// and trimming the edges is safe and expected.
export function slugify(str) {
  return str.toLowerCase().trim().replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '');
}

// Light-touch version for the slug field's own onChange, while someone is
// typing into it directly. Deliberately does NOT trim a trailing dash — that
// dash is exactly the character just typed mid-edit (e.g. typing "test-" on
// the way to "test-category"); running the strict slugify() on every
// keystroke eats it back out before the next letter can follow it, making
// the dash key look broken.
export function sanitizeSlugInput(str) {
  return str.toLowerCase().replace(/[^a-z0-9-]/g, '');
}
